import { useState } from 'react';
import dayjs from 'dayjs';
import { loadStripe } from '@stripe/stripe-js';
import StepLayout from './StepLayout';
import {
    toggleStore,
    appStore,
    permitFormStore,
    permitsStore,
    coordsStore,
} from '../../../store/Store';
import {
    fetchPermitTypeByName,
    addPermit,
    createSubCheckout,
    sendPermitEmailToAdmin,
} from '../../../firebaseConfig';

const STRIPE_PUBLISHABLE_KEY =
    'pk_live_51KEN5sIiEock6T4NDeYtHGtuCNI81lBI5zWOzKavppVS4nOOVVTYYOKs30xYmVryMIZmv2wu1YBZYZHgY4v583Jm001xXdQSFz';

const CHECKOUT_ERROR =
    'Something went wrong while starting your payment. Please try again, or contact the Parry Sound Fire Department at 705-746-2262.';

const ApplyPermit6 = () => {
    const subscribeToggle = toggleStore.useState((s) => s.subscribeToggle);
    const userInfo = appStore.useState((s) => s.userInfo);
    const loadingSpinner = appStore.useState((s) => s.loadingSpinner);
    const permitForm = permitFormStore.useState((s) => s.permitForm);
    const currentTypeValid = permitsStore.useState((s) => s.currentTypeValid);
    const currentPermitAddress = permitsStore.useState((s) => s.currentPermitAddress);
    const currentBurnCoord = coordsStore.useState((s) => s.currentBurnCoord);
    const [error, setError] = useState('');

    const checkout = async () => {
        setError('');
        appStore.update((s) => {
            s.loadingSpinner = true;
        });
        try {
            const priceId = await fetchPermitTypeByName(permitForm.type);
            const saved = await addPermit(
                permitForm,
                userInfo,
                currentPermitAddress,
                currentBurnCoord,
                priceId
            );
            if (permitForm.type === 'free') {
                sendPermitEmailToAdmin(saved);
            }
            const permit = { ...saved, subscribed: subscribeToggle };
            const stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY);
            const response = await createSubCheckout({
                ...permit,
                url: window.location.origin,
            });
            await stripe.redirectToCheckout({ sessionId: response.data });
        } catch (err) {
            appStore.update((s) => {
                s.loadingSpinner = false;
            });
            setError(CHECKOUT_ERROR);
        }
    };

    const validFrom = dayjs().format('YYYY-MM-DD');
    const validTo = dayjs().add(currentTypeValid, 'day').format('YYYY-MM-DD');

    return (
        <StepLayout
            title='Confirm your application'
            primaryLabel={loadingSpinner ? 'Processing…' : 'Proceed to payment'}
            onPrimary={checkout}
            primaryDisabled={loadingSpinner}
            hint={loadingSpinner ? 'Taking you to secure payment…' : undefined}
        >
            <dl className='flow-summary'>
                <dt>Applicant</dt>
                <dd>
                    {userInfo.first} {userInfo.last}
                </dd>
                <dt>Type</dt>
                <dd>{permitForm.type}</dd>
                <dt>Valid</dt>
                <dd>
                    {validFrom} to {validTo}
                </dd>
                <dt>Address</dt>
                <dd>{currentPermitAddress}</dd>
                <dt>Renewal</dt>
                <dd>
                    {subscribeToggle
                        ? 'Subscribed: renews automatically'
                        : 'One-time: will not auto-renew'}
                </dd>
            </dl>
            {error && (
                <p className='flow-step__error' role='alert'>
                    {error}
                </p>
            )}
        </StepLayout>
    );
};

export default ApplyPermit6;
